import { http } from '@/request/http.js'
// import defaultAvatar from '@/assets/icons/user-unlogin.png'

export default {

    state: () => ({
        accessToken: '',
        tenantId: '',
        userInfo: {
            authWay: '',
            authStatus: 1
        }
    }),

    mutations: {
        setAccessToken(state, token) {
            state.accessToken = token
        },
        setTenantId(state, id) {
            state.tenantId = id
        },
        setUserInfo(state, info){
            Object.assign(state.userInfo, info)
        }
    },

    getters: {
        
    },

    actions: {
        getUserInfo(context){
            http.get('/app-api/member/user/get').then(res => {
                // if(!res.avatar) res.avatar = defaultAvatar
                context.commit('setUserInfo', res)
                // eventBus.emit('login', res)
            }).catch(err => {
                console.log(err)
            })
        }
    }
}